import React from "react"
import { Card, Button } from "react-bootstrap"
import ReactPlayer from "react-player"
import moment from "moment"
const styleTitle = {
  textAlign: "center",
  color: "#231B69",
  paddingTop: 20,
}
const styleBody = {
  textAlign: "justify",
  color: "black",
}

export default function CardNews({ New, colorCard, onClick }) {
  const date = moment(New.Date).format("MMMM Do YYYY")
  return (
    <div>
      <Card style={{ width: "18rem", backgroundColor: colorCard }} onClick={onClick}>
        <Card.Title style={styleTitle}>{New.Title}</Card.Title>
        <Card.Subtitle style={{ alignSelf: "center", color: "#231B69" }}>
          {date}
        </Card.Subtitle>

        <Card.Body style={styleBody}>{New.Description}</Card.Body>
        {New.Picture && (
          <Card.Img
            style={{ filter: "opacity(80%)" }}
            src={New.Picture.publicURL}
          />
        )}
        {New.Youtube && (
          <ReactPlayer
            url={New.Youtube}
            loop={true}
            playing={false}
            width="18rem"
            height="auto"
            controls={true}
          />
        )}
        {New.Video && (
          <ReactPlayer
            url={New.Video.publicURL}
            loop={true}
            playing={false}
            width="18rem"
            height="auto"
            controls={true}
          />
        )}
        {New.url && (
          <Button
            target="_blank"
            rel="noopener noreferrer"
            href={New.url}
            variant="link"
            style={{
              alignSelf: "center",
              color: "#231B69",
              marginBottom: "15px",
            }}
          >
            Learn More
          </Button>
        )}
      </Card>
    </div>
  )
}
